import { useRef } from 'react'

const getScroll = () =>
  document.body.scrollTop || document.documentElement.scrollTop

const setScroll = value => {
  document.body.scrollTop = value
  document.documentElement.scrollTop = value
}

const useScrollMagic = (panel, projectPanel) => {
  const scroll = useRef()

  const doScrollMagic = panelElement => {
    if (panelElement && getScroll()) {
      const inner = panelElement.children[0]
      inner.style.marginTop = `-${getScroll()}px`
      setScroll(0)
    }
  }

  const openProjects = () => {
    const panelElement = document.querySelector(panel)
    const listElement = panelElement.querySelector('.projects-list')
    scroll.current = getScroll()
    listElement.style.marginTop = `${0 - scroll.current}px`
    listElement.style.height = `calc(100vh + ${scroll.current}px)`
    setScroll(0)
  }

  const closeProjects = projectElement => {
    const panelElement = document.querySelector(panel)
    const listElement = panelElement.querySelector('.projects-list')
    const inner = projectElement.children[0]
    listElement.style.overflow = 'visible'
    listElement.style.height = 'auto'
    inner.style.marginTop = `${scroll.current - getScroll()}px`
    projectElement.style.height = `calc(100vh + ${scroll.current + getScroll()}px)`
    setScroll(scroll.current)
  }

  return {
    panel (newPanel) {
      doScrollMagic(document.querySelector(panel))
    },

    projectPanel (newProjectPanel) {
      if (projectPanel && newProjectPanel)
        doScrollMagic(document.querySelector(projectPanel))
      else if (newProjectPanel)
        openProjects()
      else if (projectPanel)
        closeProjects(document.querySelector(projectPanel))
    },

  }
}

export const handleTransitionEnd = e => {
  const panelClasses = 'panel-inner project-panel project-panel-inner projects-list'
  panelClasses.split(' ').forEach(panelClass => {
    if (e.target.classList.contains(panelClass)) {
      e.target.style.marginTop = null
      e.target.style.overflow = null
      e.target.style.height = null
    }
  })
}

export default useScrollMagic
